<template>
  <div class="ops-monitor" v-loading="loading">
    <h3 class="monitor-title">{{ $t('overview.monitor.title') }}</h3>
    <p class="monitor-subtitle">{{ $t('overview.monitor.subTitle') }}</p>

    <div class="alarm-stats">
      <div class="stat-card" v-for="(stat, index) in alarmStatsList" :key="index" @click="handleClick(index)">
        <div class="stat-label">{{ stat.label }}</div>
        <div class="stat-value" :class="{ 'warning': stat.value > 0 }" v-if="stat.key !== 'totalAlarmRules'">{{ stat.value }}</div>
        <div v-else>
          <div v-if="stat.value === 0" class="noSet-rule">
            <span>{{ $t('text.noSetRuleTip') }}</span><br>
            <span class="setNow" @click="goPage">{{ $t('text.setNow') }}</span>
          </div>
          <span v-else class="stat-value">{{ stat.value }}</span>
        </div>
      </div>
    </div>

    <div class="alarm-list" v-if="alarmHistoryList.length">
      <div class="alarm-item" v-for="(item, index) in alarmHistoryList" :key="index">
        <div class="alarm-type">{{ item.typeName }}</div>
        <div class="alarm-content">{{ lang === 'en' ? item.contentEn : item.content }}</div>
        <div class="alarm-time">{{ item.noticeTime }}</div>
      </div>
      <!-- <div v-if="!showAll && alarmHistoryList.length > 10" class="view-more" @click="showAll = true">
        {{ $t('text.viewMore') }}
        <i class="el-icon-arrow-down"></i>
      </div> -->
    </div>

    <el-empty v-else :description="$t('text.noAbnormal')"></el-empty>
  </div>
</template>

<script>
const COOKIE_LANG = 'jdcloud_sitelang';
export default {
  name: 'OpsMonitor',
  data() {
    return {
      loading: false,
      alarmStatsList: [
        { label: this.$t('overview.monitor.totalAlarmRules'), key: 'totalAlarmRules', value: 0 },
        { label: this.$t('overview.monitor.portAlarmCount'), key: 'portAlarmCount', value: 0 },
        { label: this.$t('overview.monitor.popAlarmCount'), key: 'popAlarmCount', value: 0 },
        { label: this.$t('overview.monitor.deviceInspectionCount'), key: 'deviceInspectionCount', value: 0 },
        { label: this.$t('overview.monitor.idcInspectionCount'), key: 'idcInspectionCount', value: 0 }
      ],
      alarmHistoryList: [],
      showAll: false,
      lang: this.$cookie.get(COOKIE_LANG),
    }
  },
  computed: {
    displayedAlarmHistory() {
      if (this.showAll) {
        return this.alarmHistoryList;
      }
      return this.alarmHistoryList.slice(0, 10);
    }
  },
  mounted() {
    this.getMonitorData();
  },

  methods: {
    goPage() {
      this.$router.push({
        path: `/alarmrules/new`,
        query: { action: 'list' }
      });
    },
    getMonitorData() {
      this.loading = true;
      this.$api.getMonitorData().then(res => {
        if (res.errno === 10000 && res.data) {
          // const alarmStatsList = [
          //   { label: this.$t('overview.monitor.totalAlarmRules'), key: 'totalAlarmRules', value: '' },
          //   { label: this.$t('overview.monitor.portAlarmCount'), key: 'portAlarmCount', value: '' },
          //   { label: this.$t('overview.monitor.popAlarmCount'), key: 'popAlarmCount', value: '' },
          //   { label: this.$t('overview.monitor.deviceInspectionCount'), key: 'deviceInspectionCount', value: '' },
          //   { label: this.$t('overview.monitor.idcInspectionCount'), key: 'idcInspectionCount', value: '' }
          // ]
          // 将原始数组转为 以 key 分类到对象
          const alarmStatsData = this._.groupBy(this.alarmStatsList, 'key');
          for (const key in alarmStatsData) {
            alarmStatsData[key][0].value = res.data[key];
          }
          // groupBy 后，数组变成了对象，需要将对象转为数组
          this.alarmStatsList = this._.flatMap(alarmStatsData);
          this.alarmHistoryList = res.data.alarmHistory;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    handleClick(index) {
      if (index) return;
      this.$router.push({
        path: '/alarmrules/list'
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.ops-monitor {
  background: #fff;
  padding: 20px;
  border-radius: 8px;

  .monitor-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin: 0 0 8px 0;
  }

  .monitor-subtitle {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin: 0 0 16px 0;
  }

  .alarm-stats {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;

    .stat-card {
      flex: 1;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 8px;
      padding: 16px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // min-height: 50px;
      // border: 1px solid rgba(0, 0, 0, 0.06);
      &:hover {
        background: #e6f1fc;
        color: #1D41FF;
        cursor: pointer;
        .stat-value {
          color: #1D41FF !important;
        }
      }
      :first-child {
        cursor: pointer;
      }

      .stat-label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 8px;
        font-weight: 600;
      }

      .stat-value {
        font-size: 18px;
        font-weight: bold;
        padding-top: 12px;
        color: rgba(0, 0, 0, 0.85);
        &:hover {
          color: #1D41FF;
        }

        &.warning {
          color: #FE0016;
        }
      }
    }
    .noSet-rule {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      .setNow {
        color: #1D41FF;
        cursor: pointer;
      }
    }
  }

  .alarm-list {
    background: rgba(0, 0, 0, 0.02);
    // border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    padding: 16px;
    max-height: 480px;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: #979899 #979899;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #979899;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #b8bfcc;
      border-radius: 8px;
    }

    .alarm-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #ebeef5;
      font-size: 13px;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
      &:first-child {
          padding-top: 0;
      }

      .alarm-type {
        width: 100px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        flex-shrink: 0;
      }

      .alarm-content {
        flex: 1;
        color: rgba(0, 0, 0, 0.65);
        padding: 0 20px;
        line-height: 1.5;
      }

      .alarm-time {
        width: 140px;
        color: #909399;
        text-align: right;
        flex-shrink: 0;
      }
    }

    .view-more {
      text-align: center;
      padding-top: 12px;
      color: #1D41FF;
      cursor: pointer;
      font-size: 13px;

      &:hover {
        opacity: 0.8;
      }

      i {
        margin-left: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourceOverview/components/OpsMonitor.vue